/* eslint-disable react/no-unescaped-entities */
import { Box, CircularProgress, Divider, Typography, useMediaQuery } from '@mui/material'
import { IconHelpCircleFilled } from '@tabler/icons-react'
import { Dialog } from '~/components'
import { Button } from '~/components/Form/Button'
import { theme } from '~/utils'

export type InvoiceExternalNegotiationDialogProps = {
  isVisible: boolean
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
}

export const InvoiceExternalNegotiationDialog: React.FC<InvoiceExternalNegotiationDialogProps> = ({
  isVisible,
  onClose,
  onConfirm,
  loading = false
}) => {
  const isLowerSm = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Dialog
      isVisible={isVisible}
      title='Fatura em negociação externa'
      onClose={onClose}
      minWidth={500}
      titleIcon={<IconHelpCircleFilled style={{ color: theme.palette.primary.main }} size={32} />}
    >
      <Divider />
      <Box sx={{ display: 'flex', flexFlow: 'column', gap: '1.75rem', padding: '2rem 0' }}>
        <Typography variant='body1' color={theme.palette.grey[400]}>
          Tem certeza de que deseja alterar o status da fatura para "Negociação externa"?
        </Typography>
        <Typography variant='body1' color={theme.palette.grey[400]}>
          A ação não poderá ser desfeita
        </Typography>
      </Box>
      <Divider />
      <Box sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '1rem',
        paddingTop: '2rem',
        flexFlow: isLowerSm ? 'column' : 'row'
      }}>
        <Button
          onClick={onClose}
          color='secondary'
          disabled={loading}
          fullWidth={isLowerSm}
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant='contained'
          disabled={loading}
          fullWidth={isLowerSm}
          endIcon={loading ? <CircularProgress size={24} color='inherit' /> : null}
        >
          Alterar status
        </Button>
      </Box>
    </Dialog>
  )
}
